<script>
  import config from '../../libs/config.js';
  import func from '../../libs/functions.js';
  import api from '../../api'
  import _ from 'lodash'

  import tippy from 'tippy.js'

  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

  import _system from '../../libs/system';

	import { mapGetters, mapActions } from 'vuex'
	
	export default 
	{
		name: 'Notifications',
		data() 
        {
        	return {
            config,config,
            func: func,
            search: '',
            show: {
              teammateModal : false,
              assign: false
            },
            loading: {
              workspaces: true,
              workspaceusers: true,
              addTeammate: false,
              assignChannel: false
            },
            assign: {
              teammate:  {}
            },
            assignedAccounts: [],
            pickAccounts: [],
            newTeammate: {
              name:'',
              email: '',
              tags: [],
              department: {
                name: 'Admin',
                _id: ''
              }
            }
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getJwt','getUser', 'getRole']),
          ...mapGetters('networks', ['networksById']),
          ...mapGetters('workspaces', ['currentWorkspace','workspaces', 'workspacesById']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsByTypeName']),  
          ...mapGetters('workspaceusers', ['workspaceusers']),
          ...mapGetters('accounts', ['accounts']),
          filteredItems() {
            return this.pickAccounts.filter(item => {
              return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            })
          }
        },
      methods: {
        ...mapActions('session', ['setUser']),
        ...mapActions('workspaceusers', ['setWorkspaceusers']),
        updateWorkspaceName(){

          if(this.currentWorkspace.name.length < 2) return alert('Type at least 2 character!');

          let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            },
            body: {
              name: this.currentWorkspace.name
            }
          }
          _system.services.workspaces.update(payload, (err, res) => {
            if(err) return alert(err.message);
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Workspace name updated to: ' + this.currentWorkspace.name,
                  });
          })
        },
        assignAccount(account, teammate){
          this.loading.assignChannel = true;
          let payload = {
            query:{
              userId: teammate._id,
            },
            body: {
              pageId: account._id
            }
          }
          _system.services.workspaceusers.addAccount(payload, (err, teammate) => {
            let index = _.findIndex(this.workspaceusers, function(user) { return user._id == teammate._id });
            this.workspaceusers[index].pages = teammate.pages;
            this.setWorkspaceusers(this.workspaceusers);
              if(teammate.pages && teammate.pages.length){
                for(let [i, page] of teammate.pages.entries()){
                  for(let [e, account] of this.pickAccounts.entries()){
                    if(account._id == page._id){
                      this.$delete(this.pickAccounts, e);
                      this.loading.assignChannel = false;
                    }
                  }
                }
              }
          });
        },      
        assignBackAccount(account, teammate){
          let payload = {
            query: {
              workspaceuserId: teammate._id,
              pageId: account._id
            }
          }
          _system.services.workspaceusers.deleteAccount(payload, (err, teammate) => {
            let index = _.findIndex(this.workspaceusers, function(user) { return user._id == teammate._id });

              if(teammate.pages && teammate.pages.length){
                for(let [i, page] of teammate.pages.entries()){
                  for(let [e, account] of this.pickAccounts.entries()){
                    if(account._id == page._id) this.$delete(teammate.pages, e);
                  }
                }
              }
            this.pickAccounts.push(account)
            this.workspaceusers[index].pages = teammate.pages;
            this.setWorkspaceusers(this.workspaceusers);
          });
        },      
        assignEvent(teammate){
          this.pickAccounts = Object.assign(this.pickAccounts, this.accounts);
          
          if(teammate.pages && teammate.pages.length){
            for(let [i, page] of teammate.pages.entries()){
              for(let [e, account] of this.pickAccounts.entries()){
                if(account._id == page._id) this.$delete(this.pickAccounts, e);
              }
            }
          }

          this.assign.teammate = teammate;
          this.show.assign = true;

        },  
        deleteFromWorkspaceusers(workspaceuser){
          _system.services.workspaceusers.deleteWorkspaceUser({ workspaceuserId: workspaceuser._id }, (err, data) => {
                this.setWorkspaceusers(_.filter(this.workspaceusers, (workspace) => workspace._id != workspaceuser._id));
          })
        },
        addTeammate(){
          this.loading.addTeammate = true
          this.newTeammate.name = func.extractName(this.newTeammate.email);

          let payload = this.newTeammate;

          payload.with = 'InvitationEmail';

          _system.services.user.createWith(payload, (err, data) => {
            if(err) {
              const payload = {
                query: {
                  email: this.newTeammate.email
                }
              }

              _system.services.user.getUserByEmail(payload, (err, user) => {
              let payload = {
                workspace: this.currentWorkspace._id,
                user:  user._id,
                tags :  [this.tagsByName[this.newTeammate.department.name]._id, this.tagsByName['Invited']._id],
              }
                _system.services.workspaceusers.addWith(payload, (err, workspaceusers) => {
                  if(err) {
                  iziToast.error({
                      title: 'User is already exist'
                  });
                      this.show.teammateModal = false;
                      this.loading.addTeammate = false
                  }else{
                    this.setWorkspaceusers(workspaceusers);

                  iziToast.success({
                      title: 'Invited',
                      message: 'Notification sent to ' + this.newTeammate.email
                  });
                
                      this.show.teammateModal = false;
                      this.loading.addTeammate = false

                        // Reset
                        this.newTeammate = { name: '', email: '', department: { name: 'Admin', _id: this.tagsByName['Admin']._id } }
                
                  }})
              });
            }else{
            // 1 - Add the registered user into His/Her workspace 
              let payload1 = { "name":"Your Workspace", tags: [this.tagsByName['Individual']._id] }
              _system.services.workspaces.create(payload1, (err, workspace) => {
                if (err) return alert(err.message);
                let payload2 = {                
                  query: {
                    email: this.newTeammate.email
                  }
                };
                _system.services.user.getUserByEmail(payload2, (err, user) => {
                  let payload3 = {
                    workspace: workspace._id,
                    user:  user._id,
                    tags :  [this.tagsByName['Admin']._id]
                  }
                  _system.services.workspaceusers.add(payload3, (err, data) => {
                    if (err) return alert(err.message);
                  });
              })
              })
              //Burada bir yerde adam admin olarak eklenmismi diye bakip ona göre adama bu workspacedeki sayfalarıda eklememiz gerekiyor , bunu hangi endpointe hangi payloadi gondererek yapacagimizi eyup ile konus
              // 2 - Add the registered user into current workspace              
                let payload = {
                  workspace: this.currentWorkspace._id,
                  user:  data.user._id,
                  tags :  [this.tagsByName[this.newTeammate.department.name]._id, this.tagsByName['Invited']._id],
                }

                if(this.newTeammate.department.name == 'Admin') payload.pages = _.map(this.accounts, '_id');

                _system.services.workspaceusers.add(payload, (err, workspaceusers) => {
                  if(err) return alert(err.message);

                  this.setWorkspaceusers(workspaceusers);
              
                  iziToast.success({
                      title: 'Invited',
                      message: 'Invitation email sent to ' + this.newTeammate.email
                  });

                  this.show.teammateModal = false;
                  this.loading.addTeammate = false

                  // Reset
                  this.newTeammate = { name: '', email: '', department: { name: 'Admin', _id: this.tagsByName['Admin']._id } }
                })
              }
            })
        }
      },
      mounted() { 
        document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.show.assign = false } }) 
          tippy('#editWs', {
            content: 'Click and Edit then Press Enter to Update',
            animation: 'shift-away'
          })
        },
      created(){
      console.log(this.getRole.name)
      }
	}
</script>

<template>
  <div class="ui grid stackable">
    <div v-if="!currentWorkspace" style="position: absolute; top: 50%;left:45%;">
        <span style="font-size: 26px;"> ⏳ loading . . . </span>
    </div>

    <div v-if="workspaceusers && currentWorkspace" class="nine wide computer sixteen wide mobile column">
      <div class="ui basic large segment ">
        <p> <a href="https://slack.com" target="_blank">Slack</a> is a collaboration hub that connects your organization. It's a communication tool, comprised of channels, where you can share messages, files, and more! <a href="https://get.slack.help/hc/en-us/articles/115004071768-What-is-Slack-" target="_blank">Learn more about Slack here.</a></p>
        <p>If your team is using Slack, you can integrate your account with Juphy, and have all incoming messages, mentions, direct messages sent directly to a Slack channel. This can be especially helpful as you're starting out with social media support and your team is not in Juphy daily! </p>
        <h4>Why Slack & Juphy integration is important?</h4>
        <p>
          <ul>
            <li>Receiving notifications on Desktop</li>
            <li>Receiving notifications on Mobile Phone</li>
          </ul>
        </p>
      </div>

      <div class="ui basic segment center aligned">

      <form v-if="getRole.name == 'Admin' && !currentWorkspace.slack" :action=" config.url + '/slack/auth'" method="post">
              <input type="text" name="accessToken" v-model="getJwt" hidden>
              <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
            <input type="image" src="/img/social/btn-add-to-slack 2x.png" height="50" width="170" border="0" alt="Submit your info"> 
            </form>

      <button v-if="getRole.name == 'Admin' && currentWorkspace.slack" class="ui icon green large button" disabled> 
        <i class="check circle outline icon"></i> Successfully Integrated
      </button>

      <div class="ui basic segment" v-if="getRole.name == 'Admin' && currentWorkspace.slack">
      <p>Have a problem? Just click button below to reAuthenticate.</p>
            <form :action=" config.url + '/slack/auth'" method="post">
              <input type="text" name="accessToken" v-model="getJwt" hidden>
              <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
              <input type="image" src="/img/social/btn-add-to-slack 2x.png" height="50" width="170" border="0" alt="Submit your info"> 
            </form>
      </div>

      </div>
    

    </div>

    <div style="height: 100%; padding:0; background: #4B154B;" class="seven wide computer sixteen wide mobile column">

        <img style="width: 100%;" :src="'https://cdn.dribbble.com/users/989984/screenshots/5880822/comp_10.gif'" alt="">
        <img data-aos="zoom-in" style="width: 70%;" class="ui image centered" :src="'/img/logo_dark2.png'" alt="">

      </div>

  </div>

</template>

<style scoped>
.cloud {
position: fixed;
background: rgba(0, 0, 0, 0.28) none repeat scroll 0% 0%;
left: 0px;
top: 0px;
bottom: 0px;
right: 0px;
z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Notifications.vue